import React, { useEffect, useRef, useState } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import { FaTasks } from "react-icons/fa";
import { isMobile } from 'react-device-detect';
import DatePicker from "react-datepicker2";
//--> moment-jalaali هنگام import شدن، خود moment را وصله می کند و تقویم شمسی
//--> را به آن اضافه می کند. صفحه تیکت ها این import را دارد و تقویمش باز می شود؛
//--> این صفحه نداشت. import بدون نام است چون فقط به همان اثر جانبی نیاز داریم.
import 'moment-jalaali';
import { useNavigate } from 'react-router-dom';
import TaskProp from '../../Components/Task/TaskProp';
import Delete from '../../Components/Shared/Delete';
import Drp_Projects from '../../Components/Project/Drp_Projects';
import Drp_Categories from '../../Components/Project/Drp_Categories';
import ResponsiveList, { CardTitle, CardField, CardActions } from '../../Components/Shared/ResponsiveList';
import RowHeight from '../../Components/Shared/RowHeight';

const { Column, HeaderCell, Cell } = Table;

const Index = () => {

    //#region Const

    let navigate = useNavigate();
    const TaskRef = useRef();
    const DeleteRef = useRef();
    const PopupRef = useRef();
    const ProjectRef = useRef();
    const CategoryRef = useRef();

    const [showDrawer, setShowDrawer] = useState(false);
    const [ShowSearch, setShowSearch] = useState(false);
    const [ShowLoading, setShowLoading] = useState(true);
    const [Data, setData] = useState([]);
    const [UserList, setUserList] = useState([]);

    const [AssignTo, setAssignTo] = useState(General.GuidEmpty());
    const [Unassigned, setUnassigned] = useState(false);
    const [ProjectId, setProjectId] = useState(General.GuidEmpty());
    const [CategoryId, setCategoryId] = useState(General.GuidEmpty());
    const [State, setState] = useState(Enum.TaskStateType.OnlyOpen);
    const [Priority, setPriority] = useState(0);
    const [BeginDate, setBeginDate] = useState(null);
    const [EndDate, setEndDate] = useState(null);
    const [Title, setTitle] = useState("");
    //#endregion

    //#region Methods

    const Bind = () => {
        setShowLoading(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Task/Search?title=" + Title,
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "assignTo": AssignTo,
                "unassigned": Unassigned,
                "projectId": ProjectId,
                "categoryId": CategoryId,
                "state": State,
                "priority": Priority,
                "beginDate": BeginDate ? BeginDate.format('jYYYY/jMM/jDD') : '',
                "endDate": EndDate ? EndDate.format('jYYYY/jMM/jDD') : ''
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setData(res.data);
                setShowSearch(false);
                setShowLoading(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoading(false);
                }
            })
    }

    const BindUsers = () => {
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/User/GetAll",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setUserList([{ label: "همه", value: General.GuidEmpty() }].concat(
                    res.data.map(item => ({
                        label: item.firstName + ' ' + item.lastName,
                        value: item.id
                    }))));
            })
            .catch(() => { })
    }

    const handleTaskProp = (Id) => {
        setShowDrawer(true);
        setTimeout(() => {
            TaskRef.current.ShowEdit(Id);
        }, 500);
        if (PopupRef.current) { PopupRef.current.close(); }
    };

    const ShowDelete = (Id) => {
        if (PopupRef.current) { PopupRef.current.close(); }
        DeleteRef.current.Show(Enum.DeleteType.Task, Id);
    }

    // rowData را می گیرد چون «اعلام به کارشناس» فقط وقتی معنا دارد که مسئول
    // انجام مشخص باشد. سرور هم همین را رد می کند؛ این بررسی فقط رفت و برگشت
    // بیهوده را حذف می کند و پیام را همان لحظه نشان می دهد.
    const UpdateState = (rowData, state) => {
        if (state === Enum.TaskStateType.Waiting && !rowData.assignToFullName) {
            if (PopupRef.current) { PopupRef.current.close(); }
            General.ShowMsg(Enum.MsgType.error, "ابتدا مسئول انجام این وظیفه را مشخص نمایید");
            return;
        }
        const taskId = rowData.id;
        setShowLoading(true);
        if (PopupRef.current) { PopupRef.current.close(); }
        var RequestOption = {
            method: "Post",
            url: General.ApiRoute() + "/Task/UpdateState",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                id: taskId,
                state: state
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function () {
                Bind();
            })
            .catch(error => {
                setShowLoading(false);
                General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
            })
    }

    const SelectProject = (value) => {
        setProjectId(value);
        setCategoryId(General.GuidEmpty());
        CategoryRef.current.Get(value);
    }

    //--> کشوی جستجو تا باز نشود رندر نمی شود، پس دراپ داون پروژه را هنگام باز شدن پر می کنیم
    const OpenSearch = () => {
        setShowSearch(true);
        setTimeout(() => {
            if (ProjectRef.current) {
                ProjectRef.current.Get();
            }
        }, 300);
    }

    useEffect(() => {
        BindUsers();
        Bind();
    }, [])
    //#endregion

    return (
        <Shared pageTitle={<><FaTasks size={25} /> وظایف تیم</>}>
            <div align="left">
                <rsuite.Button appearance="primary" className="mb-2 ms-2"
                    onClick={() => handleTaskProp(General.GuidEmpty())}>
                    ایجاد وظیفه جدید
                </rsuite.Button>
                <rsuite.Button appearance="primary" color="green" className="mb-2 ms-2" onClick={Bind}>
                    بازسازی
                </rsuite.Button>
                <rsuite.Button appearance="primary" className="mb-2 ms-2" onClick={OpenSearch}>
                    جستجو
                </rsuite.Button>
            </div>
            <rsuite.Divider />
            <ResponsiveList
                fillHeight
                data={Data}
                loading={ShowLoading}
                emptyText="وظیفه ای یافت نشد"
                filters={[
                    { key: 'title', label: 'عنوان', type: 'text' },
                    { key: 'assignToFullName', label: 'مسئول انجام', type: 'text' },
                    { key: 'projectTitle', label: 'پروژه', type: 'text' },
                    { key: 'priorityComment', label: 'اولویت', type: 'select' },
                    { key: 'stateComment', label: 'وضعیت', type: 'select' },
                    { key: 'sourceComment', label: 'تعریف توسط', type: 'select' }
                ]}
                renderCard={(rowData) => (
                    <>
                        <CardTitle>{rowData.title}</CardTitle>
                        <CardField label="مسئول انجام">
                            {
                                rowData.assignToFullName ?
                                    rowData.assignToFullName
                                    :
                                    <rsuite.Tag color="orange">انتساب داده نشده</rsuite.Tag>
                            }
                        </CardField>
                        <CardField label="پروژه">{rowData.projectTitle} · {rowData.categoryTitle}</CardField>
                        <CardField label="اولویت">{rowData.priorityComment}</CardField>
                        <CardField label="مهلت انجام">
                            {
                                rowData.isOverdue ?
                                    <rsuite.Tag color="red">{rowData.dueDate}</rsuite.Tag>
                                    :
                                    rowData.dueDate
                            }
                        </CardField>
                        <CardField label="وضعیت">{rowData.stateComment}</CardField>
                        <CardField label="تعریف شده توسط">{rowData.sourceComment}</CardField>
                        <CardActions>
                            <rsuite.Button size="sm" onClick={() => handleTaskProp(rowData.id)}>ویرایش</rsuite.Button>
                            <rsuite.Button size="sm" className='ms-2'
                                onClick={() => UpdateState(rowData, Enum.TaskStateType.Waiting)}>اعلام به کارشناس</rsuite.Button>
                            <rsuite.Button size="sm" appearance="primary" color="red" className='ms-2'
                                onClick={() => ShowDelete(rowData.id)}>حذف</rsuite.Button>
                        </CardActions>
                    </>
                )}
            >
                <Table
                    rtl={true}
                    className='w-100'
                    bordered
                    headerHeight={40}
                    //--> ارتفاع سطر با طول عنوان بالا می رود تا عنوان بلند بریده نشود
                    rowHeight={RowHeight}
                    wordWrap="break-word"
                    data={Data}
                    loading={ShowLoading}
                >
                    <Column>
                        <HeaderCell><b>ردیف</b></HeaderCell>
                        <General.RowNumber />
                    </Column>
                    <Column flexGrow={3}>
                        <HeaderCell><b>عنوان</b></HeaderCell>
                        <Cell dataKey="title" />
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell><b>مسئول انجام</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                rowData.assignToFullName ?
                                    <span>{rowData.assignToFullName}</span>
                                    :
                                    <rsuite.Tag color="orange">انتساب داده نشده</rsuite.Tag>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell><b>پروژه / دسته بندی</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <>
                                    <div>{rowData.projectTitle}</div>
                                    <div>{rowData.categoryTitle}</div>
                                </>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>اولویت</b></HeaderCell>
                        <Cell dataKey="priorityComment" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>مهلت انجام</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                rowData.isOverdue ?
                                    <rsuite.Tag color="red">{rowData.dueDate}</rsuite.Tag>
                                    :
                                    <span>{rowData.dueDate}</span>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>وضعیت</b></HeaderCell>
                        <Cell dataKey="stateComment" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>تعریف توسط</b></HeaderCell>
                        <Cell dataKey="sourceComment" />
                    </Column>
                    <Column fixed="right" className='Popup'>
                        <HeaderCell>عملیات</HeaderCell>
                        <Cell>
                            {rowData => (
                                <rsuite.Whisper
                                    placement="bottomStart"
                                    controlId="control-id-with-dropdown"
                                    trigger="click"
                                    ref={PopupRef}
                                    speaker={
                                        <rsuite.Popover full>
                                            <rsuite.Dropdown.Menu>
                                                <rsuite.Dropdown.Item onClick={() => handleTaskProp(rowData.id)}>ویرایش</rsuite.Dropdown.Item>
                                                <rsuite.Dropdown.Item onClick={() => UpdateState(rowData, Enum.TaskStateType.Waiting)}>اعلام به کارشناس</rsuite.Dropdown.Item>
                                                <rsuite.Dropdown.Item onClick={() => UpdateState(rowData, Enum.TaskStateType.Approved)}>تایید شده</rsuite.Dropdown.Item>
                                                <rsuite.Dropdown.Item onClick={() => UpdateState(rowData, Enum.TaskStateType.Canceled)}>لغو شده</rsuite.Dropdown.Item>
                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.id)}>حذف</rsuite.Dropdown.Item>
                                            </rsuite.Dropdown.Menu>
                                        </rsuite.Popover>
                                    }
                                >
                                    <rsuite.Button>...</rsuite.Button>
                                </rsuite.Whisper>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </ResponsiveList>

            <rsuite.Drawer open={ShowSearch} onClose={() => setShowSearch(false)}
                placement={isMobile ? 'bottom' : 'right'} size={isMobile ? 'full' : 'sm'}>
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Actions>
                        <rsuite.Button appearance='primary' onClick={Bind}>جستجو</rsuite.Button>
                    </rsuite.Drawer.Actions>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <div className='mb-2'>
                        <label>مسئول انجام</label>
                        <rsuite.SelectPicker data={UserList} value={AssignTo}
                            onChange={value => setAssignTo(value ? value : General.GuidEmpty())}
                            className="w-100" placeholder="همه" />
                    </div>
                    <div className='mb-2'>
                        <rsuite.Checkbox checked={Unassigned}
                            onChange={() => setUnassigned(!Unassigned)}> فقط وظایف انتساب داده نشده</rsuite.Checkbox>
                    </div>
                    <div className='mb-2'>
                        <label>پروژه</label>
                        <Drp_Projects ref={ProjectRef} value={ProjectId} onSelect={SelectProject} />
                    </div>
                    <div className='mb-2'>
                        <label>دسته بندی</label>
                        <Drp_Categories ref={CategoryRef} value={CategoryId}
                            onSelect={value => setCategoryId(value ? value : General.GuidEmpty())} />
                    </div>
                    <div className='mb-2'>
                        <label>اولویت</label>
                        <rsuite.SelectPicker
                            searchable={false}
                            data={[
                                { label: "همه", value: 0 },
                                { label: "پائین", value: 1 },
                                { label: "متوسط", value: 2 },
                                { label: "بالا", value: 3 }
                            ]}
                            value={Priority}
                            onChange={value => setPriority(value)}
                            className="w-100" placeholder="همه" />
                    </div>
                    <div className='mb-2'>
                        <label>وضعیت</label>
                        <rsuite.SelectPicker
                            searchable={false}
                            data={[
                                { label: "همه", value: Enum.TaskStateType.All },
                                { label: "وظایف باز", value: Enum.TaskStateType.OnlyOpen },
                                { label: "ثبت اولیه", value: Enum.TaskStateType.Registered },
                                { label: "در انتظار اجرا", value: Enum.TaskStateType.Waiting },
                                { label: "در حال انجام", value: Enum.TaskStateType.Doing },
                                { label: "انجام داده", value: Enum.TaskStateType.Delivered },
                                { label: "برگشت خورده", value: Enum.TaskStateType.Rejected },
                                { label: "تایید شده", value: Enum.TaskStateType.Approved },
                                { label: "لغو شده", value: Enum.TaskStateType.Canceled }
                            ]}
                            value={State}
                            onChange={value => setState(value)}
                            className="w-100" placeholder="انتخاب کنید" />
                    </div>
                    <div className='mb-2'>
                        <label>مهلت از تاریخ</label>
                        <DatePicker className="form-control" isGregorian={false} timePicker={false}
                            value={BeginDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setBeginDate(value)} />
                    </div>
                    <div className='mb-2'>
                        <label>مهلت تا تاریخ</label>
                        <DatePicker className="form-control" isGregorian={false} timePicker={false}
                            value={EndDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setEndDate(value)} />
                    </div>
                    <div className='mb-2'>
                        <label>عنوان</label>
                        <rsuite.Input className='w-100' value={Title} onChange={value => setTitle(value)} />
                    </div>
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

            {/* روی دسکتاپ هم کشو است، نه پنجره. تقویم شمسی داخل Modal باز
                نمی شود ولی داخل Drawer درست کار می کند - همان چیزی که در
                کشوی جستجوی صفحه تیکت ها از قبل ثابت شده بود. */}
            <rsuite.Drawer
                open={showDrawer}
                onClose={() => setShowDrawer(false)}
                placement={isMobile ? 'bottom' : 'right'}
                size={isMobile ? 'full' : 'sm'}
            >
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>مشخصات وظیفه</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <TaskProp ref={TaskRef} onSubmit={() => { setShowDrawer(false); Bind(); }} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>
            <Delete ref={DeleteRef} onSubmit={Bind} />
        </Shared>
    );
}

export default Index;
